export const currencyBRL = (value: string): string => {
    if (!value) {
        return '';
    }
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(value));
}